// removed by extract-text-webpack-plugin
module.exports = {"itemListContainer":"fUdLq","itemList":"_1fB3r","justifyCenter":"_1zlUi","justifyFlexEnd":"_2A76d"};